// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import React from 'react'
import { number, object, string } from 'prop-types'

// NOTE - this is a special type of checkbox.
// it belongs to a group of checkboxes
// one checkbox for each match row for a given aggregate group.

// input.value is going to be an array which tracks all of the segment end ids that are selected.
// each instance of MatchRowCheckbox will have a segment end id which is the input's actual value.

const MatchRowCheckbox = ({ id, input, segmentEndId }) => {
  const checked = input.value.includes(segmentEndId)

  const handleChange = () => (
    input.onChange(
      checked
        ? input.value.filter(d => d !== segmentEndId)
        : input.value.concat(segmentEndId)
    )
  )

  return (
    <td>
      <input
        {...input}
        id={id}
        type={'checkbox'}
        checked={checked}
        value={segmentEndId}
        onBlur={() => null}
        onChange={handleChange} />
    </td>
  )
}

MatchRowCheckbox.propTypes = {
  id: string.isRequired,
  input: object.isRequired,
  segmentEndId: number.isRequired,
}

export default MatchRowCheckbox
